import React from 'react';
import { Card, CardHeader, CardText } from 'material-ui';
import { gt, ifElse, isNil, propOr } from 'ramda';

const ImportFields = ({ importedFields, contractId }) => {
  const linkToContractDetails = ifElse(
    () => isNil(contractId),
      (edit, index) => (<div key={index} style={{ color: 'rgba(0, 0, 0, 0.54)' }}>{edit}</div>),
    (edit, index) => (<a target="_blank" href={`/contracting/contract/${contractId}/details`} key={index} style={{ cursor: 'pointer', display: 'block' }}>{edit}</a>)
  );
  const linkToProductDetails = ifElse(
    () => isNil(contractId),
      (productId, edit, index) => (<div key={index} style={{ marginLeft: '12px', color: 'rgba(0, 0, 0, 0.54)' }}>{edit}</div>),
    (productId, edit, index) => (<a target="_blank" href={`/contracting/contract/${contractId}/product/${productId}/Primary`} key={index} style={{ cursor: 'pointer', display: 'block', marginLeft: '12px' }}>{edit}</a>)
  );
  const productsToImport = propOr([], 'productsToImport', importedFields);
  const locationFieldsToImport = propOr([], 'locationFieldsToImport', importedFields);
  return (
    <Card style={{ boxShadow: 'none' }}>
      <CardHeader
        style={{ height: '24px', padding: '0', marginBottom: '12px' }}
        title={<div style={{ lineHeight: '20px', marginBottom: '12px' }}>
          <div style={{ marginLeft: '5px', color: 'rgba(0, 0, 0, 0.54)', fontSize: '13px' }}>Contract Updates - <span style={{ color: '#00b3cf' }}>View all</span></div>
        </div>}
        actAsExpander
      />
      <CardText expandable style={{ padding: '0 0 0 36px', marginBottom: '12px', lineHeight: '20px' }}>
        {locationFieldsToImport.map(linkToContractDetails)}
        {
          productsToImport.map(({ productId, productName, productFields }, index) => (
            <div key={index} style={{ display: gt(productFields, []) ? 'block' : 'none' }}>
              {productName}
              {productFields.map(linkToProductDetails(productId))}
            </div>
          ))
        }
      </CardText>
    </Card>
  );
};

export default ImportFields;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/import-fields-activity-feed.jsx